import { CheckCircle2, XCircle } from 'lucide-react';
import { cn } from '@reflex/ui/lib/utils';
import { Spinner } from '@reflex/ui/components/shared/Spinner';
import { BLUEPRINT_STATUS_CONFIG } from '@/lib/status-colors';
import type { BlueprintStatus } from '@/lib/types';

const STATUS_ICONS: Record<BlueprintStatus, React.ReactNode> = {
  queued: <Spinner />,
  provisioning: <Spinner />,
  building: <Spinner />,
  build_complete: <CheckCircle2 className="h-3.5 w-3.5" />,
  failed: <XCircle className="h-3.5 w-3.5" />,
};

export function BlueprintStatusBadge({ status }: { status: BlueprintStatus }) {
  const config = BLUEPRINT_STATUS_CONFIG[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium',
        config.className,
      )}
    >
      {STATUS_ICONS[status]}
      {config.label}
    </span>
  );
}
